import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { useLocation, useNavigate } from "react-router-dom";
import "./viewpayment.css";
import BASEURL from "../../../pages/Utils/Baseurl";
import request from "graphql-request";
import { getPaymentBalanceById } from "./PaymentBalanceData";
import { IconButton, Pagination, Stack, Tooltip } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const ViewPaymentBalance = () => {
  const [data, setData] = useState(null);
  const location = useLocation();
  const navigate = useNavigate()

  const rowId = location?.state?.rowId; const [page, setPage] = useState(1);
  const rowsPerPage = 10;



  useEffect(() => {
    if (rowId) {
      fetchById();
    }
  }, [rowId]);

  const fetchById = async () => {
    try {
      const response = await request(BASEURL, getPaymentBalanceById, {
        id: rowId,
      });

      if (response?.getPaymentBalance?.success) {
        setData(response?.getPaymentBalance?.data[0]);
      } else {
        setData(null);
      }
    } catch (error) {
      console.error("Error fetching payment balance", error);
    }
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  return (
    <DashboardLayout>
      <div className="receipt-container">
        {/* Header */}
        <div className="receipt-header">
          <div style={{ display: "flex", gap: 2 }} >
            <Tooltip title="Back" arrow placement="top" >
            <IconButton onClick={() => { navigate(-1) }} >
              <ArrowBackIcon />
            </IconButton>
            </Tooltip>
            <h2>Cash Receipt</h2>
          </div>

          <span className="receipt-badge">
            Receipt Number: {data?.invoices[0]?.receiptNumber || "--"}
          </span>
        </div>


        {/* Customer Details */}
        <div className="customer-details">
          <p>
            <strong>Customer Code:</strong> {data?.customerCode || "--"}
          </p>
          <p>
            <strong>Customer Name:</strong> {data?.customerName || "--"}
          </p>
          <p>
            <strong>Credit Limit:</strong> {data?.creditLimit || "--"}
          </p>
          <p>
            <strong>Category:</strong> {data?.category || "--"}
          </p>
          <p>
            <strong>Age Of Invoice:</strong> {data?.ageOfInvoice || "--"}
          </p>
          <p>
            <strong>N Days:</strong> {data?.ndays || "--"}
          </p>
          <p>
            <strong>Total Paid Amount:</strong> {data?.amountPaid || "--"}
          </p>
          <p>
            <strong>Total Invoices:</strong> {data?.invoices?.length || 0}
          </p>
        </div>

        {/* Invoice Table */}
        <div className="section-title">Invoice Details</div>

        <table className="invoice-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Invoice Number</th>
              <th>SO Date</th>
              <th>Payment Receivable</th>
              <th>Amount Paid</th>
              <th>Outstanding Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data?.invoices?.length > 0 ? (
              data.invoices
                .slice((page - 1) * rowsPerPage, page * rowsPerPage)
                .map((inv, idx) => (
                  <tr key={inv.id || idx}>
                    <td>{(page - 1) * rowsPerPage + idx + 1}</td>
                    <td>{inv.invoiceNumber}</td>
                    <td>{inv.soDate}</td>
                    <td>{parseFloat(inv.balance).toFixed(2)}</td>
                    <td>
                      {inv?.partialPaidAmount === "None"
                        ? "Unpaid"
                        : parseFloat(inv.partialPaidAmount).toFixed(2)}
                    </td>
                    <td>{parseFloat(inv.remainingAmount).toFixed(2)}</td>
                    <td
                      className={
                        inv?.paymentStatus === "Completed"
                          ? "status-paid"
                          : inv?.paymentStatus === "Incompleted"
                            ? "status-unpaid"
                            : "status-partial"
                      }
                    >
                      {inv?.paymentStatus}
                    </td>
                  </tr>
                ))
            ) : (
              <tr>
                <td colSpan="7" style={{ padding: "16px", textAlign: "center" }}>
                  No invoice data available
                </td>
              </tr>
            )}

          </tbody>
        </table>
        {data?.invoices?.length > rowsPerPage && (
          <Stack spacing={2} alignItems="center" marginTop={2}>
            <Pagination
              count={Math.ceil(data.invoices.length / rowsPerPage)}
              page={page}
              onChange={handleChangePage}
              color="primary"
              shape="rounded"
              showFirstButton
              showLastButton
              size="small"
            />
          </Stack>
        )}

      </div>
    </DashboardLayout>
  );
};

export default ViewPaymentBalance;
